module.exports = __webpack_public_path__ + "static/media/grasshoppa-min.17ad36cf.png";